export const API_HOST = process.env.REACT_APP_API_URL
export const BRAND_CONFIG = {
    name: 'TradeMemo',
    subText: 'JOURNAL. ANALYSE. IMPROVE'
}